import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { useEffect } from "react";
import { Route, Switch, useLocation } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import ThankYou from "./pages/ThankYou";
import VehicleDetail from "./pages/VehicleDetail";
import Vehicles from "./pages/Vehicles";

// Declare fbq global to satisfy TypeScript
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
  }
}

/** Fires a Meta Pixel PageView on every route change (virtual page views for SPA). */
function MetaPixelPageView() {
  const [location] = useLocation();
  useEffect(() => {
    if (typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [location]);
  return null;
}

function Router() {
  return (
    <>
      <MetaPixelPageView />
      <Switch>
        <Route path={"/"} component={Home} />
        <Route path={"/vehicles"} component={Vehicles} />
        <Route path={"/thank-you"} component={ThankYou} />
        <Route path={"/vehicle/:id"} component={VehicleDetail} />
        <Route path={"/404"} component={NotFound} />
        <Route component={NotFound} />
      </Switch>
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="dark">
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
